var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ico-twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-5 -6.788)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6.788)",
    clipPath: "url(#ico-twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.143A13.075 13.075 0 0020.113 4.534a9.319 9.319 0 002.293-2.38 9.17 9.17 0 01-2.64.724A4.6 4.6 0 0021.787.335a9.22 9.22 0 01-2.918 1.116 4.6 4.6 0 00-7.833 4.193 13.045 13.045 0 01-9.474-4.8 4.6 4.6 0 001.422 6.138 4.582 4.582 0 01-2.083-.576 4.6 4.6 0 003.687 4.566 4.6 4.6 0 01-2.075.077 4.6 4.6 0 004.293 3.193A9.244 9.244 0 010 16.143z",
    fill: "#52a0eb"
  }))));
}

export default SvgIcoTwitter;